// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"7d548e5f","771":"801507db","950":"d55c6d28"}[chunkId] + ".chunk.css";
};